(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[178],{

/***/ "ISYn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/context/PageContext.js
var PageContext = __webpack_require__("EkOT");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// CONCATENATED MODULE: ./src/client/components/lines/button-ticket-line/ButtonTicketLine.jsx
var __jsx = react_default.a.createElement;





var ButtonTicketLine_ButtonTicketLine = function ButtonTicketLine(_ref) {
  var buttonLabel = _ref.buttonLabel,
      buttonLink = _ref.buttonLink,
      title = _ref.title;

  var _usePageContext = Object(PageContext["b" /* usePageContext */])(),
      pageType = _usePageContext.pageType;

  var track = Object(useTracking["a" /* useTracking */])({
    actionGA: 'priceBar',
    categoryGA: pageType,
    labelGA: 'getAQuote'
  });
  return __jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line Line-ButtonTicket"
  }, __jsx("div", {
    className: "mt-30 flex flex-col gap-10 rounded-12 border-1 border-lightGrey bg-white p-10 shadow-diffuse md:mt-0 md:flex-row md:items-center"
  }, __jsx("p", {
    className: "flex-1 px-10 font-sans text-14 font-bold text-black"
  }, title), __jsx(Button["a" /* Button */], {
    "data-testid": "getButtonTicketLineBtn",
    onClick: function onClick() {
      return track();
    },
    url: buttonLink
  }, buttonLabel)));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/button-ticket/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (ButtonTicketLine_ButtonTicketLine);

/***/ })

}]);